import React from "react";
import AccountReceivableModule from "../modules/AccountReceivableModule";
import CheckBounceModule from "../modules/CheckBounceModule";
import CheckTransactionModule from "../modules/CheckTransactionModule";
import CreditMemoModule from "../modules/CreditMemoModule";
import CustomerModule from "../modules/CustomerMaintenanceModule";
import FabricStyleMaintenanceModule from "../modules/FabricStyleMaintenanceModule";
import InventoryAdjustmentModule from "../modules/InventoryAdjustmentModule";
import InventoryTransferModule from "../modules/InventoryTransferModule";
import InvoiceModule from "../modules/InvoiceMaintenanceModule";
import LetterOfCreditModule from "../modules/LetterOfCreditModule";
import LogisticOrderModule from "../modules/LogisticOrderModule";
import LogisticReceiptModule from "../modules/LogisticReceiptModule";
import PickTicketModule from "../modules/PickTicketMaintenanceModule";
import PurchaseOrderInTransitModule from "../modules/PurchaseOrderInTransitModule";
import PurchaseOrderModule from "../modules/PurchaseOrderModule";
import PurchaseOrderReceiptModule from "../modules/PurchaseOrderReceiptModule";
import SalesOrderMaintenanceModule from "../modules/SalesOrderMaintenanceModule";
import VendorInvoiceModule from "../modules/VendorInvoiceModule";
import VendorMaintenanceModule from "../modules/VendorMaintenanceModule";
import RoleMaintenanceModule from "./security/RoleMaintenanceModule";
import CpmEntryMaintenanceModule from "./CpmEntryMaintenanceModule.js";
import DebitMemoMaintenanceModule from "./DebitMemoMaintenanceModule.js";





/* customer Module */
export const PopupDebitMemoModule = (props) => {
  return (
    <DebitMemoMaintenanceModule
      debitMemo={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* customer Module */
export const PopupCustomerModule = (props) => {
  return (
    <CustomerModule
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Sales Module */
export const PopupSalesModule = (props) => {
  return (
    <SalesOrderMaintenanceModule
      code={props.code}
      isSpecialViewMode={props.isSpecialViewMode ?? true}
      //  isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Item Module */
export const PopupFabricStyleModule = (props) => {
  return (
    <FabricStyleMaintenanceModule
      fabricStyleCode={props.fabricStyleCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

export const PopupPickTicketModule = (props) => {
  return (
    <PickTicketModule
      pickTicketCode={props.pickTicketCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

export const PopupInvoiceModule = (props) => {
  return (
    <InvoiceModule
      invoiceCode={props.invoiceCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Purchase Module */
export const PopupPurchaseOrderModule = (props) => {
  return (
    <PurchaseOrderModule
      code={props.code}
        isSpecialViewMode={props.isSpecialViewMode ?? true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Purchase InTransitModule */
export const PopupPurchaseInTransitModule = (props) => {
  return (
    <PurchaseOrderInTransitModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Purchase Receipt Module */
export const PopupPurchaseReceiptModule = (props) => {
  return (
    <PurchaseOrderReceiptModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* vendor Module */
export const PopupVendorModule = (props) => {
  return (
    <VendorMaintenanceModule
      vendorCode={props.vendorCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Adjustment Module */
export const PopupInventoryAdjustmentModule = (props) => {
  return (
    <InventoryAdjustmentModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Transfer Module */
export const PopupInventoryTransferModule = (props) => {
  return (
    <InventoryTransferModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* AR Module */
export const PopupARModule = (props) => {
  return (
    <AccountReceivableModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CreditMemo Module */
export const PopupCreditMemoModule = (props) => {
  return (
    <CreditMemoModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Fabric Module */
export const PopupFabricModule = (props) => {
  return (
    <div className="PurchaseOrderPopup">
      <FabricStyleMaintenanceModule
        fabricStyleCode={props.fabricStyleCode}
        isSpecialViewMode={true}
        onModuleExit={props.onModuleExit}
      />
    </div>
  );
};

/* Invoice Module */
export const VendorInvoicesModule = (props) => {
  return (
    <div className="PurchaseOrderPopup">
      <VendorInvoiceModule
        code={props.code}
        isSpecialViewMode={true}
        onModuleExit={props.onModuleExit}
      />
    </div>
  );
};
/* CheckTransaction Module */
export const PopCheckTransactionModule = (props) => {
  return (
    <div className="PurchaseOrderPopup">
      <CheckTransactionModule
        code={props.code}
        isSpecialViewMode={true}
        onModuleExit={props.onModuleExit}
      />
    </div>
  );
};

/* Purchase Module */
export const PurchaseModule = (props) => {
  return (
    <div className="PurchaseOrderPopup">
      <PurchaseOrderModule
        code={props.code}
        isSpecialViewMode={true}
        onModuleExit={props.onModuleExit}
      />
    </div>
  );
};

/* Letter Of Credits Module */
export const PopupLocModule = (props) => {
  return (
    <LetterOfCreditModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Check Bounce Module */
export const PopupCheckBounceModule = (props) => {
  return (
    <CheckBounceModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Check Bounce Module */
export const PopupLogisticOrderModule = (props) => {
  return (
    <LogisticOrderModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Check Bounce Module */
export const PopupLogisticReceiptModule = (props) => {
  return (
    <LogisticReceiptModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Role Module */
export const PopupRoleModule = (props) => {
  return (
    <RoleMaintenanceModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Cpm Module */
export const PopupCpmModule = (props) => {
  return (
    <CpmEntryMaintenanceModule
      code={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};
